import { AxiosPromise } from "axios";

import API from "./Api";
import {
  SUPPORT_CUSTOMER_ACCESS_REVOKE,
  SUPPORT_CUSTOMER_ACCESS_TOKEN,
} from "./constants";
import { ApiResponse } from "types/ApiTypes";
import { USE_ACTOR_TOKEN_HEADER } from "utils/SupportAccessUtils";

export type SupportAccessScope =
  | "read"
  | "members:write"
  | "billing:write"
  | "stripe:dashboard";

export type SupportAccessTokenRequest = {
  customerEmail?: string;
  customerId?: string;
  licenseId?: string;
  externalLicenseId?: string;
  reason: string;
  scopes: SupportAccessScope[];
};

export type SupportAccessTokenResponse = {
  token: string;
  tokenType: string;
  expiresAt: string;
  actorEmail: string;
  subjectEmail: string;
  customerId?: string;
  licenseId?: string;
  externalLicenseId?: string;
  scopes: SupportAccessScope[];
};

export default class SupportAccessApi {
  static createToken(
    payload: SupportAccessTokenRequest,
  ): AxiosPromise<ApiResponse<SupportAccessTokenResponse>> {
    return API.post(SUPPORT_CUSTOMER_ACCESS_TOKEN, payload, undefined, {
      headers: {
        "Content-Type": "application/json",
        [USE_ACTOR_TOKEN_HEADER]: "true",
      },
    });
  }

  // Revokes the active delegated token server-side. Authenticates with the
  // delegated token itself (the interceptor's default when a support access
  // session is active), so the actor-token header must NOT be set here.
  static revokeToken(): AxiosPromise<ApiResponse<void>> {
    return API.post(SUPPORT_CUSTOMER_ACCESS_REVOKE);
  }
}
